export default {
    getAllProjects: () => {
        return {
            url: `/groups/126/projects?per_page=100`,
            method: 'GET',
        };
    },
    getProject: projectId => {
        return {
            url: '/projects/:projectId',
            method: 'GET',
            route_params: {
                projectId,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/data/Projects/api.js